import { countriesToRegion } from '@/lists/countriesToRegion';
import { Region } from '@heidi/schema/ml-scribe';
import { getCountry } from '@heidi/utils/get-country';

/**
 * Best-effort region guess from the browser timezone.
 *
 * Resolves the IANA timezone to a country via {@link getCountry}, then maps
 * through {@link countriesToRegion} — the same chokepoint used for signup
 * region routing. Used when no authenticated region signal is available (e.g.
 * kinde-properties retry fallback and unauthenticated transcription routing).
 *
 * Defaults to AU when the timezone is unmapped or the country has no region.
 *
 * ⚠️ Spoofable and not for compliance-sensitive routing (APP-6111 C10).
 */
export function guessRegionFromTimezone(): Region {
  if (typeof window === 'undefined') return Region.AU;

  const countryName = getCountry()?.name;
  if (countryName) {
    const region = countriesToRegion[countryName];
    if (region) return region;
  }

  return Region.AU;
}
